import React from 'react';
import {calculatePosition, calculateWidth} from './ConversationTimelineUtils';
import ConversationTimelineIndicator from './ConversationTimelineIndicator';
import TimeBlock from './TimeBlock';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';

class ConversationTimelineRow extends React.Component {
  /**
   * the widget looks like a table, it it's really just a series of blocks
   * @param numHours number of blocks to render
   * @returns {any[]}
   */
  getBlocks(numHours, secondsPerPixel) {
    return [...Array(numHours + 1).keys()].map(i => {
      return <TimeBlock secondsPerPixel={secondsPerPixel} key={i} />;
    });
  }

  /**
   * render the bar indicator for the time and duration of the call
   * @param callInfo
   * @param firstCallDate
   * @param secondsPerPixel
   * @returns {*}
   */
  getCallIndicators(callInfo, firstCallDate, secondsPerPixel, searchFieldColorMap) {
    const extraPaddingForHover = 8;
    const calculatedInfo = callInfo.map(item => {
      return {
        call: item,
        color: isEmpty(searchFieldColorMap) ? {colorIndex: 0} : searchFieldColorMap[item.callStage],
        left: calculatePosition(item.timestamp, firstCallDate, secondsPerPixel),
        width: calculateWidth(item.durationSeconds, secondsPerPixel),
      };
    });
    return calculatedInfo.map((item, index, array) => {
      // make sure that the overlay is at least the size of the current box aka the min
      // but you also want it to optionally be 30% more to the left up to the end of the prior call time aka the max
      // only concerned when not the first item in the list
      let leftOverlay = 0.7 * item.left;
      if (index > 0) {
        const previous = array[index - 1];
        const previousEnd = previous.left + previous.width;
        leftOverlay = Math.min(item.left, Math.max(item.left - extraPaddingForHover, previousEnd));
      }
      let widthOverlay = item.width + (item.left - leftOverlay) + extraPaddingForHover;
      // when this isn't the last item, need to make sure the overlay doesn't collide with the next item.
      if (index < array.length - 1) {
        const next = array[index + 1];
        const possibleOverlayEnd = item.left + widthOverlay;
        if (possibleOverlayEnd > next.left) {
          // when the end of the overlay would go over the start of the next, subtract the difference up to the
          // extraPaddingForHover amount
          widthOverlay =
            widthOverlay - Math.min(extraPaddingForHover, possibleOverlayEnd - next.left);
        }
      }
      return (
        <ConversationTimelineIndicator
          key={item.call.id}
          call={item.call}
          left={item.left}
          width={item.width}
          leftOverlay={leftOverlay}
          widthOverlay={widthOverlay}
          color={item.color}
        />
      );
    });
  }

  render() {
    const {numHours, callInfo, firstCallDate, secondsPerPixel, searchFieldColorMap, isNoCall} =
      this.props;
    return (
      <div className={classNames('timeline-row', isNoCall ? 'no-call' : '')}>
        {this.getBlocks(numHours, secondsPerPixel)}
        {this.getCallIndicators(callInfo, firstCallDate, secondsPerPixel, searchFieldColorMap)}
      </div>
    );
  }
}

export default ConversationTimelineRow;
